import { memo } from "react";
import { Stack, Typography } from "@mui/material";
import { CommonDialog } from "@/components/common/CommonDialog";
import { PrimaryButton } from "@/components/common/PrimaryButton";
import { SecondaryButton } from "@/components/common/SecondaryButton";

interface RevokeConfirmDialogProps {
  title: string;
  description: string;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const RevokeConfirmDialog = memo(function RevokeConfirmDialog({
  title,
  description,
  busy,
  onClose,
  onConfirm,
}: RevokeConfirmDialogProps) {
  return (
    <CommonDialog
      isOpen
      handleClose={() => {
        if (!busy) onClose();
      }}
      maxWidth="xs"
      sheetTitle={title}
      footer={
        <Stack
          direction={{ xs: "column-reverse", sm: "row" }}
          spacing={1}
          justifyContent="flex-end"
        >
          <SecondaryButton
            width="fit-content"
            height="40px"
            onClick={onClose}
            disabled={busy}
          >
            Cancelar
          </SecondaryButton>
          <PrimaryButton
            width="fit-content"
            height="40px"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? "Desfazendo…" : "Confirmar"}
          </PrimaryButton>
        </Stack>
      }
    >
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </CommonDialog>
  );
});
